import React, { useMemo } from 'react';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import styles from './AddressInformations.module.sass';

const AddressInformations = ({ company }) => {
  // Construire l'adresse complète pour la géolocalisation
  const fullAddress = useMemo(() => {
    const addressParts = [
      company?.address,
      company?.address_complement,
      company?.zip_code,
      company?.city,
      company?.country || 'France'
    ].filter(Boolean);
    
    return addressParts.join(', ');
  }, [company?.address, company?.address_complement, company?.zip_code, company?.city, company?.country]);

  // URL pour carte avec marqueur (sans API key)
  const mapUrl = useMemo(() => {
    if (!fullAddress || fullAddress === 'France') {
      return null;
    }
    
    // Encoder l'adresse pour l'URL
    const encodedAddress = encodeURIComponent(fullAddress);
    
    // Utiliser Maps.ie qui est gratuit et affiche les marqueurs correctement
    return `https://maps.google.com/maps?q=${encodedAddress}&t=&z=15&ie=UTF8&iwloc=&output=embed`;
  }, [fullAddress]);
  return (
    <Card className={styles.card} title="Adresse de l'entreprise" classTitle="title-green">

      {mapUrl && (
        <div className={styles.mapContainer}>
          <div className={styles.mapWrapper}>
            <iframe
              src={mapUrl}
              className={styles.mapFrame}
              title={`Localisation de ${company?.name || 'l\'entreprise'}`}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      )}
      
      {!mapUrl && company?.address && (
        <div className={styles.noMapMessage}>
          <p>📍 Adresse incomplète pour afficher la carte</p>
          <p className={styles.noMapSubtitle}>Veuillez compléter l'adresse pour voir la localisation</p>
        </div>
      )}


    </Card >
  );
};

export default AddressInformations;
